'use strict'

export default {
  getDeposit (cb, errorCb, request = '') {
    axios.get(`/request/deposit/v2${request}`)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  postDeposit (cb, errorCb, request = {}) {
    axios.post(`/request/deposit/v2`, request)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  postDepositIntellient (cb, errorCb, request = {}) {
    axios.post(`/request/deposit-intelligent`, request)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  postDepositIntellientReseet (cb, errorCb, request = {}) {
    axios.post(`/request/deposit-intelligent/reset`, request)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/admin/api/request.js